<template>
  <div>
    <el-container direction="vertical">
      <div style="background-color: rgb(255, 255, 255); border: 1px solid #eee;">
        <div style="margin-top: 20px;">
          <el-form class="form" style="margin-left: 10px;">
            <!-- <el-form-item label="发起机构">
              <patientTree @input="input"></patientTree>
            </el-form-item> -->
            <el-form-item label="患者姓名">
              <el-input v-model="listQuery.patientName"></el-input>
            </el-form-item>

            <!-- <el-form-item label="规范管理">
              <el-select v-model="listQuery.isDiabetStdManage" placeholder="请选择">
                <el-option label="全部" :value="null"></el-option>
                <el-option label="是" value="是"></el-option>
                <el-option label="否" value="否"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="申请时间" style="margin-left: 20px;">
              <el-date-picker v-model="valueData" type="daterange" align="right"
                unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button style="margin-left: 20px;margin-right: 20px;" type="primary" @click="getListMyCodiag">查询</el-button>
            </el-form-item>
            <!-- <el-form-item>
              <el-button type="primary" @click="reportExportToExcel">导出</el-button>
            </el-form-item> -->
          </el-form>
          <el-table v-loading="listLoading" :data="manageList" border fit highlight-current-row>
            <el-table-column align="center" label="申请时间">
              <template slot-scope="scope">
                <span>{{ scope.row.applyCodiagTime }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="姓名">
              <template slot-scope="scope">
                <span>{{ scope.row.patientName }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="性别">
              <template slot-scope="scope">
                <span>{{ getGender(scope.row.gender) }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="年龄">
              <template slot-scope="scope">
                <span>{{ getAge(scope.row.birthday) }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="电话">
              <template slot-scope="scope">
                <span>{{ scope.row.phone }}</span>
              </template>
            </el-table-column>

            <!-- <el-table-column align="center" label="联系人">
              <template slot-scope="scope">
                <span>{{ scope.row.contactName }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="联系人电话">
              <template slot-scope="scope">
                <span>{{ scope.row.contactPhone }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="规范管理">
              <template slot-scope="scope">
                <span>{{ scope.row.isDiabetStdManage }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="发起人">
              <template slot-scope="scope">
                <span>{{ scope.row.applyDoctorName }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="发起机构">
              <template slot-scope="scope">
                <span>{{ scope.row.applyHospital }}</span>
              </template>
            </el-table-column> -->

            <!-- <el-table-column align="center" label="诊断详情">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="diagnose(scope.row)">诊断详情</el-button>
              </template>
            </el-table-column>

            <el-table-column align="center" label="协诊">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" v-if="$store.getters.deptName == scope.row.codiagHospital"
                  @click="consultation(scope.row)">开始协诊</el-button>
                <el-button size="mini" type="primary" v-else @click="consultationDetail(scope.row)">协诊详情</el-button>

              </template>
            </el-table-column> -->

            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="patientsDetail(scope.row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- <diagnoseDetailDialog v-if="diagnoseVisiaable" ref="diagnoseRef"></diagnoseDetailDialog> -->
          <!-- <consultationdialog @upDataList="upDataList" v-if="consultationVisiable" ref="consultation">
              </consultationdialog>
              <consultationDetailDialog v-if="consultationDetailVisiable" ref="consultationDetail">
              </consultationDetailDialog> -->
          <patient-detail v-if="patientDetailVisible" ref="PatientDetailRef"></patient-detail>
          <pagination v-show="total > 0" :total="total" :page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize"
            @pagination="turnToPage" />
        </div>
      </div>
    </el-container>


  </div>
</template>
<script>
import {
  getListMyCodiag,
  turnToMyListCodiag,
  getByIdCoDiag,
  getSearchList,
  reportToExcel,
  getlistCodiags,
  getSysDicList,
  addIntegrateManage
} from "@/api/health/Patients";
// import consultationdialog from "../glucoseRecordDialogs/consultationdialog.vue"
// import consultationDetailDialog from "../glucoseRecordDialogs/consultationDetailDialog.vue"
import patientDetail from "@/views/patient/patientDetail";
import Pagination from "@/components/Pagination";
// import diagnoseDetailDialog from "../glucoseRecordDialogs/diagnoseDetailDialog.vue";
import patientTree from '@/components/selectTree';
import { Loading } from "element-ui";
import moment from "moment";

export default {
  components: { patientDetail, patientTree, Pagination },
  props: {
    numType: String
  },
  watch: {
    numType(newValue, oldValue) {
      console.log(`Prop value changed from ${oldValue} to ${newValue}.`);
      this.listQuery.type = newValue;
      this.getListMyCodiag();
    }
  },
  data() {
    return {
      valueData: null,
      manageList: [],
      listLoading: false,
      patientDetailVisible: false,
      diagnoseVisiaable: false,
      consultationVisiable: false,
      consultationDetailVisiable: false,
      data: null,
      total: 0,
      loadingOptions: {
        text: "正在导出...",
        background: "rgba(0, 0, 0, 0.6)",
      },
      listQuery: {
        idcard: null,
        patientName: null,
        serviceName: '高血压协诊',
        type: '',
        isIntegrateManage: 1,
        noVisitHoursStart: null,
        noVisitHoursEnd: null,
        in24HourExpired:"1",
        codiagHospital: null,
        codiagStatus: null,
        codiagStartTime: null,
        codiagEndTime: null,
        codiagDealResult: null,
        pageNum: 1,
        pageSize: 10,
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      exportBody: {
        url: "/business/patientCoDiagnosis/listMyCodiag",
        headers: ['申请时间', '姓名', '性别', '年龄', '电话', '联系人', "联系人电话", '规范管理', "发起人", "发起机构"],
        keys: ['applyCodiagTime', 'patientName', 'gender', 'birthday', 'phone', 'contactName', "contactPhone", 'isDiabetStdManage', "applyDoctorName", "applyHospital"],
        body: null,
      },
      sexOptions: []
    }

  },
  created() {
    var typeData = "性别";
    this.getSystemDictList(typeData);

    this.getListMyCodiag();
  },
  methods: {
    //查询结果导出
    reportExportToExcel() {
      console.log(
        "查询结果导出",
        `表格${moment(new Date()).format("YYYYMMDDHHmm")}.xlsx`
      );

      let loadingInstance = Loading.service(this.loadingOptions);

      this.exportBody.url = '/business/patientCoDiagnosis/listMyCodiag?page=' + this.listQuery.pageNum + '&pageSize=' + this.listQuery.pageSize;
      this.exportBody.body = this.listQuery;
      console.log("导出表格请求body：", this.exportBody);

      reportToExcel(this.exportBody)
        .then((res) => {
          console.log("查询表格导出====", res);

          this.$nextTick(() => {
            loadingInstance.close();
          });

          let blob = new Blob([res], { type: "application/force-download" });
          console.log(blob);
          let fileReader = new FileReader();
          fileReader.readAsDataURL(blob);
          fileReader.onload = (e) => {
            let a = document.createElement("a");
            a.download = `高血压协诊管理-24小时过期${moment(new Date()).format(
              "YYYYMMDDHHmm"
            )}.xlsx`;
            a.href = e.target.result;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          };
        })
        .catch((error) => {
          this.$nextTick(() => {
            loadingInstance.close();
          });

          console.log(error);

          this.$message({
            message: "导出失败",
            type: "error",
          });
        });
    },
    getSystemDictList(typeName) {
      var typeData = {
        "typeName": typeName
      };
      getSysDicList(typeData).then(res => {
        var records = [];
        if (res.msg == "success") {
          var data = res.data;
          records = data.records;
        }
        this.sexOptions = records;
        console.log(this.sexOptions);
      }).catch(err => {
        console.log(err);
      })
    },
    getGender(gender) {
      var option = this.sexOptions.filter(v => v.value == gender)[0];
      return option.name;
    },
    // 选取机构
    input(value) {
      // this.listQuery.managerHospitals = value;
    },
    // 协诊完成之后刷新列表
    upDataList() {
      this.turnToPage();
    },
    // 日期格式转化
    getParseDate(time, type) {
      if (type == 1) {
        var newTime = new Date(time);
      } else if (type == 2) {
        var newTime = new Date((new Date(time) / 1000 + 86400) * 1000);
      }
      // 获取完整的年份(4位)
      var year = newTime.getFullYear();
      // 获取月份(0-11,0代表1月)
      var month = newTime.getMonth() + 1;
      // 获取日期(1-31)
      var date = newTime.getDate();

      return year + "-" + (month < 10 ? '0' + month : month) + "-" + (date < 10 ? '0' + date : date);
    },
    // 获取我发起的列表
    getListMyCodiag() {
      this.listLoading = true;

      this.listQuery.codiagStartTime = this.valueData ? this.getParseDate(this.valueData[0], 1) : null;
      this.listQuery.codiagEndTime = this.valueData ? this.getParseDate(this.valueData[1], 2) : null;

      this.listQuery.type = this.numType;

      getlistCodiags(this.listQuery).then((res) => {
        this.listLoading = false;
        if (res.msg == "success") {
          this.manageList = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    // 跳转协诊记录表
    consultation(data) {
      this.consultationVisiable = true;
      this.$nextTick(() => {
        this.$refs["consultation"].init(data)
      })
    },
    // 跳转协诊详情
    consultationDetail(data) {
      this.consultationDetailVisiable = true;
      const params = {
        id: data.id
      }
      getByIdCoDiag(params).then(res => {
        if (res.msg == "success") {
          data = res.data;
          this.$nextTick(() => {
            this.$refs["consultationDetail"].init(data)
          })
        }
      })
    },
    // 計算年齡
    getAge(birthday) {
      if (birthday == null) return "";
      var birthdays = new Date(birthday.replace(/-/g, "/"));
      let d = new Date();
      let age =
        d.getFullYear() -
        birthdays.getFullYear() -
        (d.getMonth() < birthdays.getMonth() ||
          (d.getMonth() == birthdays.getMonth() &&
            d.getDate() < birthdays.getDate())
          ? 1
          : 0);
      return age;
    },
    // 跳转诊断列表
    diagnose(rowValue) {
      this.diagnoseVisiaable = true;
      this.$nextTick(() => {
        this.$refs.diagnoseRef.init(rowValue);
      })
    },
    // 跳转至相应病人档案详情页
    patientsDetail(row) {
      let params = {
        healthNo: row.healthNo
      }
      getSearchList(params).then((res) => {
        if (res.msg == "success") {
          console.log("========", res, row)
          var data = res.data.records[0];
          this.patientDetailVisible = true;
          this.$nextTick(() => {
            this.$refs["PatientDetailRef"].init(data);
          });
        }
      }).catch((error) => {
        console.log(error);
      })
    },
    // 导航跳转查询列表页
    turnToPage() {
      this.listLoading = true;

      this.listQuery.codiagStartTime = this.valueData ? this.getParseDate(this.valueData[0], 1) : null;
      this.listQuery.codiagEndTime = this.valueData ? this.getParseDate(this.valueData[1], 2) : null;

      turnToMyListCodiag(this.listQuery).then((res) => {
        this.listLoading = false;
        if (res.msg == "success") {
          this.manageList = res.data.records;
          this.total = res.data.total;
        }
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.form {
  display: flex;

  ::v-deep {
    .el-form-item__content {
      display: flex;
    }
  }
}

::v-deep {

  .el-form-item {
    margin-left: 5px;
  }

  .cell {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
}
</style>